<frontend-app-loading *ngIf="appLoadingSrv.isLoading$ | async"></frontend-app-loading>
<router-outlet></router-outlet>
